import { ReactTableDefaults } from 'react-table'
import ReactTable from 'react-table';
import "react-table/react-table.css";

Object.assign(ReactTableDefaults, {
    previousText: 'Précédent',
    nextText: 'Suivant',
    loadingText: 'Chargement...',
    noDataText: 'Aucun résultat',
    pageText: 'Page',
    ofText: 'sur',
    rowsText: 'lignes',
});

export default ReactTable;


// WEBPACK FOOTER //
// ./src/react-table-atis.js